<template>
  <Dialog
    v-model:visible="isVisible"
    modal
    :closable="true"
    class="w-full max-w-md"
    @hide="$emit('close')"
  >
    <template #header>
      <div class="flex items-center gap-3">
        <i class="fas fa-triangle-exclamation text-amber-500 text-xl"></i>
        <span class="font-semibold text-lg">{{ title }}</span>
      </div>
    </template>

    <div class="flex flex-col items-center gap-4 py-4 text-center">
      <div class="flex items-center justify-center w-16 h-16 rounded-full bg-amber-100">
        <i class="fas fa-circle-exclamation text-amber-500 text-3xl"></i>
      </div>

      <p class="text-gray-700">{{ message }}</p>

      <ul v-if="errors.length" class="w-full text-left space-y-2">
        <li
          v-for="(error, index) in errors"
          :key="index"
          class="flex gap-2 text-sm text-gray-700 bg-amber-50 rounded-md px-3 py-2"
        >
          <i class="fas fa-circle-exclamation text-amber-500 mt-0.5"></i>
          <span>{{ error }}</span>
        </li>
      </ul>
    </div>

    <template #footer>
      <div class="flex justify-end">
        <Button label="Close" @click="isVisible = false" />
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import { computed } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Unable to Submit',
  },
  message: {
    type: [String, Array],
    default: 'We were unable to process your submission. Please try again.',
  },
  errors: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['close', 'update:visible']);

const isVisible = computed({
  get: () => props.visible,
  set: (value) => {
    emit('update:visible', value);
    if (!value) emit('close');
  },
});
</script>
